<template>
  <div class="community-info">
    <div class="app-panel-list app-region blank-t-v blank-b-v blank-l-h blank-r-h">
      <div>
        <p>楼栋数</p>
        <p>{{ info.building_count }}栋</p>
      </div>
      <div>
        <p>房屋数</p>
        <p>{{ info.house_count }}间</p>
      </div>
      <div>
        <p>住户数</p>
        <p>{{ info.owner_count }}人</p>
      </div>
    </div>
    <div class="app-info-list app-region blank-b-v blank-l-h blank-r-h">
      <div class="page-title">社区信息</div>
      <a-row type="flex" align="middle">
        <a-col>社区名称</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>{{info.name}}</a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle">
        <a-col>社区简称</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>{{info.prefix}}</a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle">
        <a-col>所在地</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>{{info.province}}{{info.city}}{{info.area}}</a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle">
        <a-col>物业团队</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>
              <a-tag class="large" v-for="(value, index) in info.tissue_staff" :key="index">{{ value.name }}</a-tag>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle">
        <a-col>物业电话</a-col>
        <a-col>
          <a-row type="flex" align="middle">
            <a-col>{{ info.mobile }}</a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import CommunityService from "@/io/community.js";

export default {
  name: 'CommunityInfo',
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      CommunityService.info(this.$getCookie('communityId'))
        .then((res) => {
          this.info = res;
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="less" scoped>
</style>